var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 145,
    viewBox: "0 0 173 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_744)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.38 84.5698C130.883 84.5698 142.64 72.8128 142.64 58.3098C142.64 43.8068 130.883 32.0498 116.38 32.0498C101.877 32.0498 90.1199 43.8068 90.1199 58.3098C90.1199 72.8128 101.877 84.5698 116.38 84.5698Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.49 135.22C82.2466 135.22 95.02 122.446 95.02 106.69C95.02 90.933 82.2466 78.1597 66.49 78.1597C50.7333 78.1597 37.96 90.933 37.96 106.69C37.96 122.446 50.7333 135.22 66.49 135.22Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9199 73.3798C94.618 73.3798 102.48 65.5179 102.48 55.8198C102.48 46.1216 94.618 38.2598 84.9199 38.2598C75.2217 38.2598 67.3599 46.1216 67.3599 55.8198C67.3599 65.5179 75.2217 73.3798 84.9199 73.3798Z",
    fill: "#00A5D5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64 87.5L159.04 86.6C163.25 78.48 165.64 69.27 165.64 59.5C165.64 26.92 139.22 0.5 106.64 0.5C78.36 0.5 54.74 20.4 48.99 46.96C51.17 46.66 53.38 46.5 55.64 46.5C82.7 46.5 104.64 68.44 104.64 95.5C104.64 103.62 102.65 111.27 99.16 118.01C101.61 118.32 104.11 118.5 106.64 118.5C122.39 118.5 136.69 112.32 147.27 102.26L171.64 107.5L158.64 87.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6399 46.5C28.5799 46.5 6.63989 68.44 6.63989 95.5C6.63989 105.9 9.88989 115.54 15.4199 123.47L1.63989 139.5L28.7299 136.44C36.4499 141.53 45.6999 144.5 55.6399 144.5C82.6999 144.5 104.64 122.56 104.64 95.5C104.64 68.44 82.6999 46.5 55.6399 46.5Z",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172.29,
    height: 145,
    fill: "white",
    transform: "translate(0.429932)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo2);
export default __webpack_public_path__ + "static/media/illustration-logo-2.37c3f4346cd718033babc87f8936ef40.svg";
export { ForwardRef as ReactComponent };